import { TranslatedText } from '../Translation';

export interface ProductOptionKVP {
  key: string;
  value: string;
  valueNameTranslation: TranslatedText;
}

export const productOptionKVPFromResponse = (
  responseData: any,
): ProductOptionKVP => ({
  key: responseData.option_key_name,
  value: responseData.option_value_name,
  valueNameTranslation: responseData.option_value_name_translation ?? {},
});

export const productOptionKVPToUpsertRequest = (
  productOptionKVP: ProductOptionKVP,
) => ({
  option_key_name: productOptionKVP.key,
  option_value_name: productOptionKVP.value,
  option_value_name_translation: productOptionKVP.valueNameTranslation,
});
